export default __webpack_public_path__ + "static/media/prodotti-utilitalia.767790f2.jpg";